import ConsumersPage from './ConsumersPage';
export default ConsumersPage;
